import { render } from "./CustomProductLabel.vue?vue&type=template&id=60301eda&scoped=true"
import script from "./CustomProductLabel.vue?vue&type=script&lang=js"
export * from "./CustomProductLabel.vue?vue&type=script&lang=js"

import "./CustomProductLabel.vue?vue&type=style&index=0&id=60301eda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60301eda"]])

export default __exports__